
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M6.545 0c3.52 0 6.391 1.235 6.54 2.783l.006.126v3.273a5.455 5.455 0 11-6.985 8.36c-2.703-.053-4.225-.586-5.088-1.233-.461-.346-.722-.717-.864-1.036a1.863 1.863 0 01-.15-.548l-.002-.027-.001-.024L0 11.638l.11-.001H0V2.908C0 1.302 2.93 0 6.545 0zm3.273 6.182a4.364 4.364 0 100 8.727 4.364 4.364 0 000-8.727zM12 10.896v2.137l-2.319-.347v-1.79h2.32zM1.455 9.151v2.45a.454.454 0 00.028.081c.04.09.142.264.408.463.431.324 1.315.727 3.067.881a5.442 5.442 0 01-.571-2.985c-1.276-.177-2.2-.504-2.862-.852l-.07-.038zm8.073 1.745v1.74l-1.892-.282v-1.458h1.892zm0-1.892v1.74l-1.892.03v-1.35l1.892-.42zM12 8.364v2.368l-2.319.042v-1.84l2.32-.57zM1.455 4.738v2.637l.022.023c.127.122.355.309.725.504.513.27 1.313.563 2.512.717a5.47 5.47 0 012.404-2.814l-.19.008-.383.005c-2.056 0-3.89-.421-5.09-1.08zm10.181 0a6.808 6.808 0 01-.945.423c.325.052.642.133.946.24v-.663zm-5.09-3.283c-1.653 0-3.08.3-4.038.726-.481.214-.78.431-.94.598a.72.72 0 00-.102.13.72.72 0 00.102.13c.16.167.459.384.94.598.959.426 2.385.727 4.037.727 1.653 0 3.08-.301 4.038-.727.481-.214.78-.43.94-.598a.719.719 0 00.102-.13.72.72 0 00-.102-.13c-.16-.167-.459-.384-.94-.598-.959-.426-2.385-.726-4.038-.726z"}})])
          )
        }
      }
    